module.exports = __webpack_public_path__ + "card_view.0362665b.webp";